import { render, staticRenderFns } from "./GroupphaseWithKOGameOverview.vue?vue&type=template&id=1ebb3128&scoped=true&"
import script from "./GroupphaseWithKOGameOverview.vue?vue&type=script&lang=js&"
export * from "./GroupphaseWithKOGameOverview.vue?vue&type=script&lang=js&"
import style0 from "./GroupphaseWithKOGameOverview.vue?vue&type=style&index=0&id=1ebb3128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebb3128",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBadge,VTab,VTabItem,VTabs})
